<script>
  import pageFooter from "@/components/pageFooter.vue";
  import dataDialog from "@/views/warn/warnconfig/DataDialog.vue";
  export default {
    data() {
      return {
        queryForm: {
          current: 1,
          total: 0,
          size: 10
        },
        tableData: [],
        mstpList: [],
        yjlbbhList: [],
        warnconfig: {
          visible: false,
          formData: {},
          yjlevelList: []
        },
        visible: false
      }
    },
    components: { pageFooter, dataDialog },
    methods: {
      tableRowClassName() {
        return {
          backgroundColor: '#ffffff',
          fontSize: '1.2rem',
          fontWeight: 'normal',
          fontStretch: 'normal',
          fontFamily: 'PingFang SC',
          color: '#616f7b',
        };
      },
      handleSizeChange(val) {
        this.queryForm.size = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.queryForm.current = val;
        this.page();
      },
      init() {
        this.request.get('/rm-bstmp/queryNrMstps').then(
            (res) => {
              if (res.ok) {
                this.mstpList = res.data;
              } else {
                this.$message.error(res.error.message);
              }
            }
        );
        this.request.get('/rm-sdictionary/v1/query/'+ '07').then(
            (res) => {
              if (res.ok) {
                this.yjlbbhList = res.data;
              } else {
                this.$message.error(res.error.message);
              }
            }
        );
      },
      page() {
        this.request.post('/rm-tyjgz/queryYjgzPage', this.queryForm).then(
            (res) => {
              if (res.ok) {
                this.tableData = res.data.records;
                this.queryForm.total = res.data.total;
              } else {
                this.$message.error(res.error.message);
              }
            }
        )
      },
      query() {
        this.queryForm.current = 1;
        this.page();
      },
      save() {
        this.warnconfig.operate = 'add';
        this.warnconfig.title = '添加预警规则';
        this.warnconfig.visible = true;
      },
      edit(val) {
        this.warnconfig.operate = 'edit';
        this.warnconfig.title = '修改预警规则';
        this.warnconfig.formData = JSON.parse(JSON.stringify(val));
        this.warnconfig.visible = true;
      },
      del(val) {
        this.request.delete(`/rm-tyjgz/deleteYjgz/${val}`).then(
            (res) => {
              if (res.ok) {
                this.$message.success("删除成功！");
                this.query();
              } else {
                this.$message.error(res.error.message);
              }
            }
        );
      },
      clear() {
        this.queryForm = {
          current: 1,
          total: 0,
          size: 10
        };
        this.$refs.multipleTable.clearSort();
        this.$refs.multipleTable.clearSelection();
        this.query();
      },
      sortChange({ prop, order }) {
        this.queryForm.sortCol = prop;
        this.queryForm.order = order;
        this.queryForm.current = 1;
        this.page();
      },
      yjlbbhReset() {
        this.queryForm.yjlbbh = '';
        this.query();
      },
      handleClick(val) {
        this.edit(val);
      }
    },
    mounted() {
      this.init();
      this.query();
    },
    watch:{
      "$store.state.head.skCd"() {
        //调用页面查询方法
        this.query();
      },
    }
  };
</script>

<template>
    <el-container style="padding: 20px;">
      <el-header>
        <el-row>
          <el-col :span="24">
            <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                class="queryButton"
                @click="save">
              新增
            </el-button>
            <el-input
                v-model="queryForm.stcdnm"
                :maxlength="11"
                placeholder="预警对象"
                style="width: 200px;height: 32px;margin: 0 10px;">
            </el-input>
            <el-button
                type="primary"
                size="small"
                style="background-color: #a8a8a8;border-color: #a8a8a8;"
                @click="clear">
              重置
            </el-button>
            <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="query">
              搜索
            </el-button>
          </el-col>
        </el-row>
      </el-header>
      <el-main class="commonDiv">
        <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%;"
            height="calc(100% - 60px)"
            max-height="calc(100% - 60px)"
            border
            @sort-change="sortChange"
            :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'5rem'}"
            :row-style="tableRowClassName">
          <el-table-column
              prop="yjlbnm"
              align="center">
            <template #header>
              <span>预警类别</span>
              <el-popover
                  placement="bottom"
                  trigger="click"
                  width="200">
                <el-select v-model="queryForm.yjlbbh" style="margin-right: 10px;" placeholder="预警类别" @change="query">
                  <el-option
                      v-for="item in yjlbbhList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                  </el-option>
                </el-select>
                <el-row style="margin-top: 2vh;">
                  <el-col :span="12">
                    <el-button class="dgSave" @click="yjlbbhReset">重 置</el-button>
                  </el-col>
                </el-row>
                <i slot="reference" class="el-icon-sxld"></i>
              </el-popover>
            </template>
            <template v-slot="scope">
              <a style="color: #46adf5;cursor: pointer;" @click="handleClick(scope.row)">{{ scope.row.yjlbnm }}</a>
            </template>
          </el-table-column>
          <el-table-column
              prop="yjlevelmc"
              label="预警等级"
              align="center">
            <template v-slot="scope">
              <span v-if="scope.row.yjlevelmc === '关注'" style="color: #FA9001;">{{ scope.row.yjlevelmc }}</span>
              <span v-if="scope.row.yjlevelmc === '警戒'" style="color: #EA3323;">{{ scope.row.yjlevelmc }}</span>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              width="300"
              label="预警对象">
            <template v-slot="scope">
              <span>{{scope.row.stnm}}（{{scope.row.stcd}}）</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="yz"
              align="right"
              label="预警值">
          </el-table-column>
          <el-table-column
              prop="yjcxsj"
              align="center"
              label="持续时间 （h）">
          </el-table-column>
          <el-table-column
              prop="nr"
              width="300"
              label="内容">
            <template v-slot="scope">
              <el-tooltip effect="light" :disabled="scope.row.nr.length < 50" class="el-tooltip-omit">
                <div class="omit">{{ scope.row.nr }}</div>
                <template #content>
                  <div :style="{ width: 200 + 'px' }">{{ scope.row.nr }}</div>
                </template>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="autoSend"
              align="center"
              label="是否自动发布">
            <template v-slot="scope">
              <span v-if="scope.row.autoSend">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              sortable="custom"
              prop="no"
              label="序号">
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-tooltip content="删除" effect="light">
                <el-popconfirm
                    title="确定删除吗？"
                    @confirm="del(scope.row.id)"
                >
                  <img
                      src="~@/assets/images/operates/delete.png"
                      alt=""
                      slot="reference"
                      style="cursor: pointer;margin-left: 1vh"
                  />
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="commonPage">
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :total="queryForm.total"
              :current-page.sync="queryForm.current"
              :page-size="queryForm.size"
              layout="total, prev, pager, next,sizes, jumper">
          </el-pagination>
        </div>
        <data-dialog :warnconfig.sync="warnconfig" @query="query"></data-dialog>
      </el-main>
    </el-container>
</template>

<style scoped>
::v-deep .el-input__inner {
  height: 32px;
}

::v-deep .el-input--suffix .el-input__inner {
  width: 100% !important;
}

::v-deep  .el-input__icon{
  line-height: 28px !important;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 208px);
  padding: 20px 20px 0 20px;
}

.commonPage {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}

/deep/ .el-pagination{
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}


.omit {
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.el-icon-sxld {
  width: 10px;
  height: 9px;
  margin-left: 10px;
  cursor: pointer;
  background: url('../../assets/icons/sxld.png');
}

.dgSave {
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
</style>